﻿(function ($, d) {

    function LoadPies () {
        var charts = document.querySelectorAll("[data-pie-chart]");
        for (var i = 0; i < charts.length; i++) {
            var thisPieChart = charts[i];
            var ctx = charts[i].querySelector("canvas").getContext("2d");
            if (!ctx) {
                return;
            }
            var pieChartData = [];
            var keyValElems = thisPieChart.querySelectorAll("[data-key-val]");
            for (var x = 0; x < keyValElems.length; x++) {
                pieChartData.push(keyValElems[x].dataset.keyVal);
            }
            var pieChartColours = [];
            var keyColElems = thisPieChart.querySelectorAll("[data-key-col]");
            for (var y = 0; y < keyColElems.length; y++) {
                pieChartColours.push(keyColElems[y].dataset.keyCol);
            }
            var config = {
                type: "doughnut",
                data: {
                    datasets: [
                        {
                            data: pieChartData,
                            backgroundColor: pieChartColours,
                            borderColor: 'rgb(255,255,255)',
                            borderWidth: 2,
                        }
                    ]
                },
                options: {
                    aspectRatio: 1,
                    cutoutPercentage: "75",
                    hover: { mode: null },
                    tooltips: {
                        enabled: false,
                    }
                }
            };
            new Chart(ctx, config);
        }
    }

    $(d).ready(function () {
        LoadPies();

        document.addEventListener('load-pies', function () {
            LoadPies();
        });
    });
})(jQuery, document);